module.exports = __webpack_public_path__ + "media/honey-icons/icon-order-placed-02638ab5.svg";